import type { NavigationConfig } from '@core/ui/navigation';
import { navigationModuleConfig } from './moduleConfig';
import { headerNavigationItems } from './headerItems';
import { mobileNavigationItems } from './mobileItems';
import { menuNavigationItems } from './menuItems';

export const zoocasaNavigationConfig: NavigationConfig = {
  module: {
    behavior: navigationModuleConfig.behavior,
  },
  structure: {
    header: headerNavigationItems,
    mobile: mobileNavigationItems,
    menu: menuNavigationItems,
  },
};

export {
  navigationModuleConfig,
  headerNavigationItems,
  mobileNavigationItems,
  menuNavigationItems,
};

export { createHomeTypeQuery } from './utils'; 